export default "__VITE_ASSET__DygD7o6K__"